import { IHomeOwnerSchema } from '../../../../repositories/monolith-python/entities/offer/HomeOwnerSchema';
import { IOfferState } from '../../../../redux/reducers';

export const mapHomeowner = (offer: IOfferState): IHomeOwnerSchema | null => {
  const { homeOwner } = offer;

  if (!homeOwner) {
    return null;
  }

  if (!homeOwner.secondName) {
    // Удостоверяемся, что в информации о собственнике есть поле Отчество с пустой строкой, и заменяем её на null
    homeOwner.secondName = null;
  }

  return homeOwner;
};
